// extracted by mini-css-extract-plugin
export default {"container":"pre-form_container","formInfo":"pre-form_formInfo","footer":"pre-form_footer"};